import classNames from "classnames";

import { useTracker } from "../../../hooks/useTracker";
import useTranslation from "../../../hooks/useTranslation";
import { ElementClickAction } from "../../../lib/TrackingAdapter";
import { SubscriptionPeriod } from "../../../types";

import style from "./SubscriptionPeriodPicker.module.css";

export interface SubscriptionPeriodPickerProps extends React.HTMLAttributes<HTMLDivElement> {
  period: SubscriptionPeriod;
  onPeriodChange: (period: SubscriptionPeriod) => void;
  badgetext?: string;
}

const SubscriptionPeriodPicker = ({
  period,
  onPeriodChange,
  className,
  ...props
}: SubscriptionPeriodPickerProps) => {
  const { t, m } = useTranslation();
  const tracker = useTracker();

  const onClick = (selectedPeriod: SubscriptionPeriod) => {
    if (selectedPeriod === period) {
      return;
    }

    tracker.trackButtonClick({
      elementId: "pricing_card_period_picker",
      action: ElementClickAction.SUBSCRIPTION_PERIOD_PICK,
      location: "pricing_card",
      details: selectedPeriod,
    });

    onPeriodChange(selectedPeriod);
  };

  return (
    <div className={classNames(className, style.picker)} {...props}>
      <button
        className={classNames(period === SubscriptionPeriod.Yearly && style.selected)}
        onClick={() => onClick(SubscriptionPeriod.Yearly)}
      >
        {t(m.Button.Yearly)}
      </button>
      <button
        className={classNames(period === SubscriptionPeriod.Monthly && style.selected)}
        onClick={() => onClick(SubscriptionPeriod.Monthly)}
      >
        {t(m.Button.Monthly)}
      </button>
      {props.badgetext && (
        <div
          className={classNames(
            style.badge,
            period === SubscriptionPeriod.Yearly && style.selected
          )}
        >
          {props.badgetext}
        </div>
      )}
    </div>
  );
};

export default SubscriptionPeriodPicker;
